import type { ComponentProps } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { Checkbox } from '@/components/common/checkbox';

import { FormField } from '../form-field';

type CheckboxBaseProps = Omit<
  ComponentProps<typeof Checkbox>,
  'checked' | 'defaultChecked' | 'onChange' | 'children'
>;

export type CheckboxFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = CheckboxBaseProps & {
  name: TName;
  control: Control<TFieldValues>;
  /** Inline trailing label (checkbox layout — not the label-above of text fields). */
  label?: string;
  help?: string;
};

export function CheckboxField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ name, control, label, help, ...rest }: CheckboxFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} help={help}>
      {({ field }) => (
        <Checkbox
          {...rest}
          id={name}
          checked={Boolean(field.value)}
          onChange={(event) => field.onChange(event.target.checked)}
          onBlur={field.onBlur}
          ref={field.ref}
        >
          {label}
        </Checkbox>
      )}
    </FormField>
  );
}
